<template>
    <div class="mesS" @click="page(data.jump_kind,data.jump_id)">
      <!-- 支付提醒消息 -->
      <h1>{{ data.title }}</h1>
      <h2>{{data.show_time}}</h2>
      <p v-html="setCss(data.content)"></p>
      <div class="clickM">
          <span>点击查看详情</span>
          <i></i>
      </div>
    </div>
  </template>
  
  <script>
  export default {
      props:{
          data:Object,
      },
      data(){
          return{
  
          }
      },
      methods:{
          setCss(con){
              //标记圈子样式 
              con = con.replace('《','<span style="color:#FE484A">').replace('》','</span>');
              return con;
          },
          page(kind,id){
              if(kind == 'circleMain'){
                  location.href = `/circle/${id}`;
              }
          }
      }
  }
  </script>
  
  <style lang="scss" scoped>
      .mesS{
          margin: 14px 12px;
          background: #FFFFFF;
          border-radius: 5px;
          padding: 10px 15px;
          position: relative;
          &::before{
              position: absolute;
              content: "";
              display: block;
              top: 0;
              left: 0;
              width: 100%;
              height: 6.5px;
              background: #FF7C4D;
              border-top-right-radius:5px;
              border-top-left-radius:5px;
          }
  
          >h1{
  
              font-size: 15px;
              font-weight: 500;
              color: #333333;
              line-height: 31px;
          }
  
          >h2{
  
              font-size: 12px;
              font-weight: 400;
              color: #939393;
              line-height: 16.5px;
              margin-bottom: 11px;
          }
  
          >p{
  
              font-size: 13px;
              font-weight: 400;
              color: #333333;
              line-height: 18.5px;
          }
  
          .clickM{
              border-top: 1px solid #F1F1F1;
              margin-top: 10px;
              padding-top: 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              >span{
                  font-size: 13px;
                  font-weight: 400;
                  color: #636363;
                  line-height: 18.5px;
              }
              >i{
                  display: block;
                  width: 6.5px;
                  height: 11.5px;
                  background: url(https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/mesS.png) no-repeat;
                  background-size: 100%;
              }
          }
      }
  </style>